<template>
  <!-- Address map card (pin + address + Directions), same card on the appointment, S&R, RQ and UQ details -->
  <div class="w-full p-[15px] rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
    <div class="googleApi rounded-[15px] overflow-hidden mt-0">
      <GMapMap :center="position" :zoom="16" map-type-id="terrain" style="width: 100%" class="h-[180px]" :options="{
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      }">
        <GMapMarker :position="position" />
      </GMapMap>
    </div>
    <div class="flex flex-col justify-between mt-3">
      <p v-if="address" class="text-[14px] largeDesktop:text-[16px] text-left m-0 text-[#333333]">{{ address }}</p>
      <div class="!w-max mobile:mt-3 laptop:!mt-2.5 laptop:!flex">
        <button type="button"
          class="group flex items-center gap-2 rounded-full px-[14px] py-1 transition-all duration-300 hover:bg-[#A084E8] [@media(max-width:1023px)]:!bg-[#A084E8] border-1 border-[#A084E8] bg-[#fff]"
          @click="openGoogleMaps">
          <span
            class="inline-block font-normal text-[14px] font-roboto text-[#A084E8] group-hover:text-[#fff] [@media(max-width:1023px)]:!text-[#fff]">Directions</span>
          <img src="../../assets/images/diraction-iconPurple.png" alt="icon"
            class="group-hover:!hidden [@media(max-width:1023px)]:!hidden block w-[20px] h-[20px] object-contain">
          <img src="../../assets/images/diraction-iconWhite.png" alt="icon"
            class="group-hover:!block [@media(max-width:1023px)]:!block hidden w-[20px] h-[20px] object-contain">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lat: { type: [Number, String], default: 0 },
    lng: { type: [Number, String], default: 0 },
    address: { type: String, default: "" },
  },
  computed: {
    position() {
      return { lat: Number(this.lat) || 0, lng: Number(this.lng) || 0 };
    },
  },
  methods: {
    openGoogleMaps() {
      const url = `https://maps.google.com/?q=${this.position.lat},${this.position.lng}`;
      // Windows: new tab; elsewhere the maps app can take the link
      if (navigator.platform.indexOf("Win") > -1) window.open(url, "_blank");
      else window.location.href = url;
    },
  },
};
</script>
